"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderActionMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const archive_1 = require("./archive");
const OrderActionMenu = props => {
    const { order, disabled } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-label": "more", id: "contract-menu-button", "aria-controls": open ? "contract-actions-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: handleClick, disabled: disabled, "data-testid": "ContractActionsMenuButton", sx: { marginLeft: "auto" }, children: (0, jsx_runtime_1.jsx)(icons_material_1.MoreVert, {}) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Menu, { id: "order-actions-menu", anchorEl: anchorEl, open: open, onClose: handleClose, onClick: handleClose, keepMounted: true, children: (0, jsx_runtime_1.jsx)(archive_1.OrderArchiveMenuItem, { order: order }) })] }));
};
exports.OrderActionMenu = OrderActionMenu;
//# sourceMappingURL=index.js.map